import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import kebabCase from 'lodash/kebabCase'
import { dynamicDataAttribute } from 'helpers/utils'

const PromoBlock = ({
  className,
  name,
  promotions = [],
  showPromotionModal,
  removeCouponActionHandler,
  noEdit,
  ...props
}) =>
  <Wrapper { ...dynamicDataAttribute(kebabCase(name)) } className={ className } { ...props } noEdit={ noEdit }>
    <Name { ...dynamicDataAttribute(`${kebabCase(name)}-name`) }>{ name }</Name>
    {
      promotions.map(({ promotionName, promotionId, isUserAppliedPromotion, couponCode }, index) =>
        <LinkWrapper key={ `${promotionId}-${couponCode}` }>
          <Link { ...dynamicDataAttribute(`${kebabCase(name)}-link`) } key={ index } prevent bolder to="/" handler={ showPromotionModal(promotionId) }>
            { promotionName }
          </Link>
          {
            !noEdit && isUserAppliedPromotion &&
              <CloseIcon asset="icon-circle-close" onClick={ removeCouponActionHandler(couponCode) } />
          }
        </LinkWrapper>
      )
    }
  </Wrapper>

PromoBlock.propTypes = {
  atId: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  noEdit: PropTypes.bool,
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  removeCouponActionHandler: PropTypes.func,
  showPromotionModal: PropTypes.func
}

export default PromoBlock

const Wrapper = styled.div`
  padding: 20px 0 16px;

  & + & {
    border-top: 1px solid ${Theme.colors.light_grey};
    padding-top: 16px;
  }

  ${props => props.noEdit && css`
    ${Media.desktop`
      padding: 0 0 16px;
    `}
  `}
`

const Name = styled.div`
  margin-bottom: 6px;
  font-weight: 700;
  line-height: 19px;
  color: ${Theme.colors.sub_grey};
`

const Link = styled(A)`
  display: block;
  margin-right: 20px;

  & + & {
    padding-top: 10px;
  }
`

const LinkWrapper = styled.div`
  position: relative;
  padding: 4px 0;
`

const CloseIcon = styled(Icon)`
  position: absolute;
  right: 0;
  bottom: 4px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`
